import { ApplicationConfig, importProvidersFrom } from "@angular/core";
import { provideRouter } from "@angular/router";
import { routes } from "./routes";
import { provideToastr } from "ngx-toastr";
import { provideHttpClient, withInterceptors, HttpClient } from "@angular/common/http";
import { tokenInterceptor } from "@interceptors/token.interceptor";
import { MatNativeDateModule } from "@angular/material/core";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { IMAGE_CONFIG } from "@angular/common";
import { MatPaginatorIntl } from "@angular/material/paginator";
import { TranslateMatPaginatorIntl } from "./mat-paginator-intl.translate";

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: MatPaginatorIntl, useClass: TranslateMatPaginatorIntl },
    provideRouter(routes),
    { provide: IMAGE_CONFIG, useValue: { disableImageSizeWarning: true } },
    provideToastr(),
    provideHttpClient(withInterceptors([tokenInterceptor])),
    importProvidersFrom(
      MatNativeDateModule,
      TranslateModule.forRoot({
        defaultLanguage: 'en',
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient],
        },
      })
    ),
  ],
};
